import React, { useState } from "react";
import { Input } from "@progress/kendo-react-inputs";
import { label, number } from "../../config/constants";
import { validateLength, validatePassword } from "../../shared/validators/validator";

/**
 * Screen 3 of the in-app forgot password flow.
 * Shown after OTP verification — lets the user set a new password.
 *
 * @author Sarthak Arora
 */
const SetNewPassword = ({ onPasswordChange }) => {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showNpError, setShowNpError] = useState(false);
  const [showNpErrorMsg, setShowNpErrorMsg] = useState(false);
  const [showCpError, setShowCpError] = useState(false);

  const isNewPasswordValid = (value) =>
    validateLength(value, number.EIGHT) && value.length <= number.SIXTEEN;

  const notify = (np, cp) => {
    const isValid = validatePassword(np, cp, number.EIGHT);
    if (onPasswordChange) onPasswordChange({ newPassword: np, isValid });
  };

  const handleNewPassword = (value) => {
    setNewPassword(value);
    if (isNewPasswordValid(value)) {
      setShowNpError(false);
      if (confirmPassword && confirmPassword !== value) {
        setShowNpErrorMsg(true);
      } else {
        setShowNpErrorMsg(false);
        setShowCpError(false);
      }
    } else {
      setShowNpError(true);
      setShowNpErrorMsg(false);
    }
    notify(value, confirmPassword);
  };

  const handleConfirmPassword = (value) => {
    setConfirmPassword(value);
    if (isNewPasswordValid(newPassword)) {
      if (value && value !== newPassword) {
        setShowCpError(true);
      } else {
        setShowCpError(false);
        setShowNpErrorMsg(false);
      }
    }
    notify(newPassword, value);
  };

  return (
    <div className='set-new-password-container'>
      <div className='form-group'>
        <label htmlFor='reset-new-password'>{label.NEW_PASSWORD}</label>
        <Input
          type='password'
          id='reset-new-password'
          name='newPassword'
          placeholder={label.NEW_PASSWORD}
          value={newPassword}
          maxLength={number.SIXTEEN}
          onChange={(e) => handleNewPassword(e.target.value)}
          className='form-control'
          autoComplete='off'
          required
        />
        {showNpError && (
          <small className='text-danger d-flex'>{label.PASSWORD_LENGTH_MISMATCH}</small>
        )}
        {showNpErrorMsg && (
          <small className='text-danger'>{label.PASSWORD_MISMATCH}</small>
        )}
      </div>

      <div className='form-group mt-3'>
        <label htmlFor='reset-confirm-password'>{label.CONFIRM_PASSWORD}</label>
        <Input
          type='password'
          id='reset-confirm-password'
          name='confirmPassword'
          placeholder={label.CONFIRM_PASSWORD}
          value={confirmPassword}
          maxLength={number.SIXTEEN}
          onChange={(e) => handleConfirmPassword(e.target.value)}
          className='form-control'
          autoComplete='off'
          required
        />
        {showCpError && (
          <small className='text-danger'>{label.PASSWORD_MISMATCH}</small>
        )}
      </div>
    </div>
  );
};

export default SetNewPassword;

